import { BulkErrorsAndWarningsService } from '../../../services/bulk-errors-and-warnings-service';
import { emptyArray } from 'ui-components/default-props/empty';
import * as EntitiesActions from '../../../store/entities/entities.actions';

import { BATCH_JOB_ENTITY_GROUP_NAME, BATCH_JOB_ENTITIY_ID_ATTRIBUTE, BATCH_JOB_STATUS_COMPLETED } from './constants';
import { normalizeDataArray, buildEntityPayload } from './data-helpers';

const errorsAndWarningsTypes = [
  BulkErrorsAndWarningsService.getBatchValidatedErrorType(),
  BulkErrorsAndWarningsService.getBatchValidatedWarningType(),
];

const processNonFinalMessages = (pusherMessages) => {
  return pusherMessages.reduce(
    (acc, { data }) => {
      return {
        total: data?.total,
        completedCount: (acc.completedCount || 0) + (data?.count || 0),
        messages: [...acc.messages, ...(data?.messages || emptyArray)],
      };
    },
    { total: 0, completedCount: 0, messages: [] },
  );
};

const processFinalMessage = (finalMessage, processedMessages) => {
  const jobId = finalMessage?.messageGuid;

  const errorOrWarningMessages = processedMessages.messages
    .filter((m) => errorsAndWarningsTypes.includes(m?.Type))
    .map((messageData) => ({
      ...messageData,
      id: messageData.OrderID.toString(),
      fulfillmentPlanId: messageData.OrderID.toString(),
      message: messageData.Message,
      type: messageData.Type,
    }))
    .sort((a, b) => a.fulfillmentPlanId - b.fulfillmentPlanId);

  const filteredErrors = errorOrWarningMessages.filter((err) => err?.type === BulkErrorsAndWarningsService.getBatchValidatedErrorType());
  const filteredWarnings = errorOrWarningMessages.filter(
    (err) => err?.type === BulkErrorsAndWarningsService.getBatchValidatedWarningType(),
  );

  const errorsAndWarnings = [];

  if (filteredErrors.length) {
    errorsAndWarnings.push(BulkErrorsAndWarningsService.getLabelBatchCreateErrors(filteredErrors));
  }
  if (filteredWarnings.length) {
    errorsAndWarnings.push(BulkErrorsAndWarningsService.getLabelBatchCreateWarnings(filteredWarnings));
  }

  return { jobId, errorsAndWarnings };
};

export const processPusherMessages = (normalizedMessages) => {
  const nonFinalMessages = normalizedMessages.filter((message) => !message?.data?.final);
  const finalMessage = normalizedMessages.find((message) => message?.data?.final);
  const processedMessages = processNonFinalMessages(nonFinalMessages);
  return processFinalMessage(finalMessage, processedMessages);
};

export const prepareReduxUpdatesOnJobDone = (batchJob) => {
  const updatedJob = {
    ...batchJob,
    status: BATCH_JOB_STATUS_COMPLETED,
  };

  const normalizedJob = normalizeDataArray(BATCH_JOB_ENTITY_GROUP_NAME, BATCH_JOB_ENTITIY_ID_ATTRIBUTE, [updatedJob]);
  const jobPayload = buildEntityPayload(normalizedJob);
  return EntitiesActions.entitiesLoad(jobPayload);
};
